/*
export const RESERVATIONS_COLLECTION = "reservations";
export const USERS_COLLECTION = "users";
export const APPOINTMENTS_COLLECTION = "appointments";
export const DOCTORS_COLLECTION = "doctors";
export const AVAILABILITY_COLLECTION = "availability";
export const APPOINTMENT_STATUSES = {
  PENDING: "pending",
  CONFIRMED: "confirmed",
  COMPLETED: "completed",
  CANCELED: "canceled",
};
export const APPOINTMENT_TYPES = {
  URGENT: "urgent",
  SCHEDULED: "scheduled",
};
export const APPOINTMENT_STATUSES_ARRAY = [
  APPOINTMENT_STATUSES.PENDING,
  APPOINTMENT_STATUSES.CONFIRMED,
  APPOINTMENT_STATUSES.COMPLETED,
  APPOINTMENT_STATUSES.CANCELED,
];
export const APPOINTMENT_TYPES_ARRAY = [
  APPOINTMENT_TYPES.URGENT,
  APPOINTMENT_TYPES.SCHEDULED,
];
export const APPOINTMENT_TYPES_OPTIONS = [
  { label: "Urgent", value: APPOINTMENT_TYPES.URGENT },
  { label: "Scheduled", value: APPOINTMENT_TYPES.SCHEDULED },
];
export const APPOINTMENT_STATUSES_OPTIONS = [
  { label: "Pending", value: APPOINTMENT_STATUSES.PENDING },
  { label: "Confirmed", value: APPOINTMENT_STATUSES.CONFIRMED },
  { label: "Completed", value: APPOINTMENT_STATUSES.COMPLETED },
  { label: "Canceled", value: APPOINTMENT_STATUSES.CANCELED },
];
export const DOCTOR_SPECIALTIES = [
  "General Practitioner",
  "Pediatrician",
  "Dermatologist",
  "Cardiologist",
  "Gynecologist",
  "Orthopedic Surgeon",
  "Neurologist",
  "Psychiatrist",
  "Ophthalmologist",
  "Dentist",
];
export const DOCTOR_SPECIALTIES_OPTIONS = DOCTOR_SPECIALTIES.map(
  (specialty) => ({
    label: specialty,
    value: specialty,
  })
);

export const projectData = {
  callCenterPhone: "+201035536523",
};
*/

/*
npm run build
firebase deploy --only hosting:manzely
*/
/*
"availability"
"reservations"
*/
export const projectData = () => {
  return homeProjectData;
};

const APPOINTMENT_TYPES = {
  URGENT: "urgent",
  SCHEDULED: "scheduled",
};

const DOCTOR_SPECIALTIES = [
  "General Practitioner",
  "Pediatrician",
  "Dermatologist",
  "Cardiologist",
  "Gynecologist",
  "Orthopedic Surgeon",
  "Neurologist",
  "Psychiatrist",
  "Ophthalmologist",
  "Dentist",
];

const APPOINTMENT_STATUSES = {
  PENDING: "pending",
  CONFIRMED: "confirmed",
  COMPLETED: "completed",
  CANCELED: "canceled",
};

const APPOINTMENT_STATUSES_ARRAY = [
  APPOINTMENT_STATUSES.PENDING,
  APPOINTMENT_STATUSES.CONFIRMED,
  APPOINTMENT_STATUSES.COMPLETED,
  APPOINTMENT_STATUSES.CANCELED,
];
const APPOINTMENT_TYPES_ARRAY = [
  APPOINTMENT_TYPES.URGENT,
  APPOINTMENT_TYPES.SCHEDULED,
];
const APPOINTMENT_TYPES_OPTIONS = [
  { label: "Urgent", value: APPOINTMENT_TYPES.URGENT },
  { label: "Scheduled", value: APPOINTMENT_TYPES.SCHEDULED },
];
const APPOINTMENT_STATUSES_OPTIONS = [
  { label: "Pending", value: APPOINTMENT_STATUSES.PENDING },
  { label: "Confirmed", value: APPOINTMENT_STATUSES.CONFIRMED },
  { label: "Completed", value: APPOINTMENT_STATUSES.COMPLETED },
  { label: "Canceled", value: APPOINTMENT_STATUSES.CANCELED },
];
const PROJECT_NAME = "ONLINE_DOC";
export const homeProjectData = {
  PROJECT_NAME: "ONLINE_DOC",
  RESERVATIONS_COLLECTION: `${PROJECT_NAME}_reservations`,
  USERS_COLLECTION: `${PROJECT_NAME}_users`,
  APPOINTMENTS_COLLECTION: `${PROJECT_NAME}_appointments`,
  DOCTORS_COLLECTION: `${PROJECT_NAME}_doctors`,
  AVAILABILITY_COLLECTION: `${PROJECT_NAME}_availability`,

  APPOINTMENT_TYPES: {
    URGENT: "urgent",
    SCHEDULED: "scheduled",
  },

  DOCTOR_SPECIALTIES_OPTIONS: DOCTOR_SPECIALTIES.map((specialty) => ({
    label: specialty,
    value: specialty,
  })),

  callCenterPhone: "+201035536523",

  /*
  usename: myadmin@manzely.com
  passward: alyaly

  DM:
  username: admin@fayrouz.com
  password: 456789
  */

  /*
npm run build
firebase deploy --only hosting:manzely
*/
  /*
"availability"
"reservations"
*/
};
